import { Slide } from "@mui/material";
import moment from "moment";
import React from "react";
import { DATE_TIME_FORMATS } from "../../data/constants";
import { NotificationStatusUpdates } from ".";
import { NotificationDataType } from "../../redux/slices/notifications";

export default function RenderReconNotification({ data, background = "white",
  textColor = "black", onRead }: { onRead: (val: string) => void; data: NotificationDataType, background?: string, textColor?: string }) {
  const read = data?.status === NotificationStatusUpdates.read;
  const previousDate =
    moment(data?.notificationTime).format(DATE_TIME_FORMATS.dmy) !==
    moment(new Date()).format(DATE_TIME_FORMATS.dmy);

  return <Slide direction="left" in={true} mountOnEnter unmountOnExit>
    <div
      className={`online-order-card w-full rounded-[8px] cursor-pointer bg-[${background}] text-${textColor} mt-[20px] shadow-[0px_3px_6px_#00000034]`}
      onClick={() => {
        onRead(data.messageId)
      }}
    >
      <div
        className={`border-b p-16 font-semibold text-18 flex justify-between items-center  ${read ? "opacity-40" : ""
          }`}
      >
        <div>{data.title}</div>
        {!read && <div className="bg-[#397ef5] rounded-[100%] h-[10px] w-[10px]"></div>}
      </div>

      <div className={`p-16 text-15 ${read ? "opacity-40" : ""}`}>
        {data.message}
      </div>
      <div className="mt-8 p-16 pt-12 border-t flex justify-between items-center ">
        <div className="flex w-[65%] justify-start opacity-40">
          <div className="flex flex-col pl-5 w-[100%]">
            <div className="text-14 w-full text-ellipsis overflow-hidden whitespace-nowrap">
              <span>
                {previousDate &&
                  moment(data?.notificationTime).format(
                    DATE_TIME_FORMATS.doMMM
                  )}
                {previousDate && <>, &nbsp;</>}
                {moment(data?.notificationTime).format(
                  DATE_TIME_FORMATS.hhmmA
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Slide>
}